module.exports = __webpack_public_path__ + "img/about1-2.b6f2aba5.png";